export const visit = (vm, at) => {
at({ "en": { "breezeSetupMeetingNotetakerAgent": { "setupPrompt": "Help me set up Meeting Notetaker for my portal." } } });
};